import styled from 'styled-components';
import vector from '../../../../assets/equipment/vector.svg'

export const InputDiv = styled.div`
  height: fit-content;
  position: relative;
  
  background-image: url(${vector});
  background-size: 18px 9px;
  background-repeat: no-repeat;
  background-position: right 15px center;
  cursor: pointer;

`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 700;
  display: block;
  margin-bottom: 0.5rem;
`

export const Input = styled.input`
  width: 100%;
  height: 40px;
  background-color: #ebebeb;
  border: 0;
  border-radius: 2rem;
  padding: 1rem;
  outline: none;
  &.clientToFreight {
    width: 90%;
  }
`

export const SearchOptions = styled.ul`
  position: absolute;
  list-style: none;
  z-index: 9100;
  background-color: #fff;
  border: 1px solid #ebebeb;
  border-radius: 1rem;
  overflow-x: hidden;
  max-height: 10rem;
  overflow-y: auto;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);

  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`

export const Option = styled.li<{ isSelected?: boolean }>`
  cursor: pointer;
  padding: 0.8rem 1rem;
  background-color: ${(props) => (props.isSelected ? '#F4F4F4' : '#FFF')};
  border-bottom: 1px solid #ebebeb;
  user-select: none;

  &:hover {
    background-color: #f4f4f4;
  }
`
export const VectorIcon = styled.img`
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);

  pointer-events: none;
`;